import { createRoot } from "react-dom/client";
import "./styles.css";
import "react-photo-view/dist/react-photo-view.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { App } from "@/app";

createRoot(document.getElementById("root")!).render(<App />);
